// PSTUDIO-4026: helper that keeps entering edit on a wrapped Message cell from
// growing the row (and thereby jumping the virtualized workflows table).
//
// The auto-grown edit <textarea> used to expand the row from the wrap clamp to the
// full text height in one step, so the virtualizer re-measured and shifted every
// following row. Clamping the textarea to the SAME height the read view already
// uses removes that. (The other half of the fix — focus({ preventScroll: true })
// plus an explicit, header-aware re-scroll via computeRevealScrollDelta — lives at
// the cell.tsx call sites.)
//
// Pure so it can be unit-tested without a DOM (pro-studio has no RTL — React logic
// is exercised through pure helpers).

// The read-view clamp for a wrapped Message cell (mirrors `cellViewWrapStyle` in
// cell.tsx). Applying the identical value to the edit <textarea> gives full
// view↔edit height parity, so edit entry never changes the row height.
export const MESSAGE_WRAP_MAX_HEIGHT =
  'max(80px, var(--c-editor-table-tr-height, 80px))';

/**
 * The max-height to apply to an edit-mode <textarea>, or `undefined` for no clamp.
 * Only the Message column with wrap ON is clamped (parity with its read view);
 * every other textarea column keeps its unbounded auto-grow (out of scope).
 */
export function resolveEditorCellMaxHeight(opts: {
  isMessageColumn: boolean;
  wrapEnabled: boolean;
}): string | undefined {
  return opts.isMessageColumn && opts.wrapEnabled
    ? MESSAGE_WRAP_MAX_HEIGHT
    : undefined;
}
